import React, { useEffect } from "react";
import { enablePopover } from "../public/js/core";

export default React.memo(function SecureTransactionNotice() {
  useEffect(() => {
    enablePopover();
  }, []);

  return (
    <a
      href="#"
      tabIndex="0"
      data-toggle="popover"
      data-trigger="focus"
      title="Your transaction is secure"
      data-content="We work hard to protect your security and privacy. Our payment security system encrypts your information during transmission. We do not directly store your credit card information on our servers."
      onClick={(e) => e.preventDefault()}
    >
      <i className="fa fa-lock mr-2 mb-2"></i>
      Secure transaction
    </a>
  );
});
